import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, Row, Select, Space } from 'antd';
import accountService from '../../api/account.service';
import { ADD_MODE, SUCCESS_STATUS } from '../../utility/Constants';
import TextArea from 'antd/lib/input/TextArea';
import commonUtility from '../../utility/Utils';
const { Option } = Select;




const purchaseCardView = {
    background: "#fbfbfb",
    backgroundColor: "fbfbfb",
    padding: "7px 10px",
    paddingTop: "15px",
    borderRadius:'12px',
    boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    marginBottom:'10px',
    border:'1px solid #ddd'
   
  };

const PurchaseDetailView = (props) => {


    const [accountList, setAccountList] = useState([]);
    const [cgstList, setCgstList] = useState([]);
    const [sgstList, setSgstList] = useState([]);
    const [igstList, setIgstList] = useState([]);



    useEffect(() => {
        accountService.accountListForJournal().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "CGST", usedfor: "I" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setCgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "SGST", usedfor: "I" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setSgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "IGST", usedfor: "I" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setIgstList(res.data.response_data);
            }
        });
    }, []);


    useEffect(() => {
        
        if(props.form.getFieldValue('mode') == ADD_MODE){
            props.form.setFieldsValue({
                purchase_details: [
                    { 
                        particulars: '', 
                        qty: '' ,  
                        rate: '' ,  
                        item_value: '' ,  
                        cgst_id: '' ,  
                        cgst_amount: '' ,  
                        sgst_id: '' ,  
                        sgst_amount: '',  
                        igst_id: '' ,  
                        igst_amount: '' ,  
                        item_gst_total: '' ,  
                        item_total_amount: '' ,  
                    }
                ],
            });
        }
        
      }, []);


    return (
        <>

            <h4 style={{ marginTop: '10px' }}>Purchase Details</h4>
            {/* <Divider style={{margin:2}}/> */}
            <Form.List name="purchase_details" >
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (

                        <div style={purchaseCardView} key={`purchasedetail-${index}`}>
                            <Row gutter={20} >

                            <Col xs={24} xl={6}>
                                    <Form.Item
                                        {...field}
                                        label="Particular"
                                        name={[field.name, 'particulars']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Particular Required',
                                            },
                                        ]}
                                    >
                                        <TextArea autoSize />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="Qty"
                                        name={[field.name, 'qty']}
                                       
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required',
                                            },
                                        ]}
                                    >
                                        <Input onChange={(value, event) => props.calItemAmount(event,value,index )} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="Rate"
                                        name={[field.name, 'rate']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required',
                                            },
                                        ]}
                                    >
                                        <Input onChange={(value, event) => props.calItemAmount(event,value,index )} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={4}>
                                    <Form.Item
                                        {...field}
                                        label="Amount"
                                        name={[field.name, 'item_value']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'cgst_id']}
                                        label="CGST">
                                        <Select className="text-left" allowClear={false} 
                                        onSelect={(value, event) => props.onGSTChange(value,event,index)}
                                        >
                                            <Option key="0" value="" rate="0" type="CGST">Select</Option>
                                            {cgstList.length > 0
                                                ? cgstList.map((cgst_list) => (
                                                    <Option
                                                        key={cgst_list.id}
                                                        value={cgst_list.id}
                                                        rate={cgst_list.rate}
                                                        type="CGST"
                                                    >
                                                        {cgst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        {...field}
                                        label=""
                                        name={[field.name, 'cgst_rate']}
                                        hidden={false}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item> */}

                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="CGST Amt."
                                        name={[field.name, 'cgst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'sgst_id']}
                                        label="SGST">
                                        <Select className="text-left" 
                                        onSelect={(value, event) => props.onGSTChange(value,event,index)}
                                        >
                                            <Option key="0" value="" rate="0" type="SGST">Select</Option>
                                            {sgstList.length > 0
                                                ? sgstList.map((sgst_list) => (
                                                    <Option
                                                        key={sgst_list.id}
                                                        value={sgst_list.id}
                                                        rate={sgst_list.rate}
                                                        type="SGST"
                                                    >
                                                        {sgst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        {...field}
                                        label=""
                                        name={[field.name, 'sgst_rate']}
                                        hidden={false}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item> */}

                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="SGST Amt."
                                        name={[field.name, 'sgst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                            </Row>
                            <Row gutter={20}>

                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'igst_id']}
                                        label="IGST">
                                        <Select className="text-left" 
                                        onSelect={(value, event) => props.onGSTChange(value,event,index)}
                                        >
                                            <Option key="0" value="" rate="0" type="IGST">Select</Option>
                                            {igstList.length > 0
                                                ? igstList.map((igst_list) => (
                                                    <Option
                                                        key={igst_list.id}
                                                        value={igst_list.id}
                                                        rate={igst_list.rate}
                                                        type="IGST"
                                                    >
                                                        {igst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        {...field}
                                        label=""
                                        name={[field.name, 'igst_rate']}
                                        hidden={false}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item> */}

                                </Col>

                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        label="IGST Amt."
                                        name={[field.name, 'igst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={4}>
                                    <Form.Item
                                        {...field}
                                        label="Net GST"
                                        name={[field.name, 'item_gst_total']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={4}>
                                    <Form.Item
                                        {...field}
                                        label="Net Amount"
                                        name={[field.name, 'item_total_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>



                                <Col xs={24} xl={2}>


                                    <Form.Item
                                        {...field}
                                        label=" "
                                        name={[field.name, 'action']}

                                    >
                                        {/* <MinusCircleOutlined onClick={() => remove(field.name)} /> */}

                                        <Button
                                            type="danger"
                                            icon={<DeleteOutlined />}
                                            shape="circle"
                                            // onClick={() => remove(field.name)}
                                            onClick={() => props.removeDetail(index)}
                                        />
                                    </Form.Item>

                                </Col>

                                {/* <Col>
                                    <Form.Item
                                        {...field}
                                        label=" "
                                        name={[field.name, 'helper']}

                                    >
                                    <p>Note : Either you can select CGST,SGST or IGST</p>
                                    </Form.Item>
                                </Col> */}

                            </Row>

                            </div>

                        ))}

                        <Form.Item>
                            <Button shape='round' className='custom-button-green' onClick={() => add()}  icon={<PlusOutlined />}>
                                Add Purchase Details
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </>



    );
};
export default PurchaseDetailView;